/**
 * Every department any brand can sell: the product feed's department slugs, with a default name. A
 * brand picks the ones it shows, with its own names, order and lines (brand.json `departments`);
 * products in the others are hidden on that brand's site. Stage environments share one catalog
 * and search index across brands, so the catalog itself always holds every department.
 */
export const ALL_DEPARTMENTS = [
  { slug: "power-tools", name: "Power Tools" },
  { slug: "outdoor-power-equipment", name: "Outdoor Power Equipment" },
  { slug: "parts-service", name: "Parts & Service" },
  { slug: "paint", name: "Paint" },
  { slug: "hardware", name: "Hardware" },
  { slug: "gift-cards", name: "Gift Cards" },
] as const;

export type DepartmentSlug = (typeof ALL_DEPARTMENTS)[number]["slug"];

export const DEPARTMENT_SLUGS = ALL_DEPARTMENTS.map((d) => d.slug) as [DepartmentSlug, ...DepartmentSlug[]];

/** A department's default name, the same for every brand (the search index uses it). */
export const defaultDepartmentName = (slug: string): string =>
  ALL_DEPARTMENTS.find((d) => d.slug === slug)?.name ?? slug;
